import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.557 2.288a.655.655 0 0 0-.656-.657.655.655 0 0 0-.656.657v9.406c0 1.208.979 2.187 2.187 2.187h11.156a.655.655 0 0 0 .657-.656.655.655 0 0 0-.657-.656H3.432a.874.874 0 0 1-.875-.875zm11.621 3.09a.656.656 0 0 0-.927-.927L9.997 7.703l-2.16-2.16a.654.654 0 0 0-.927 0L4.061 8.385a.656.656 0 0 0 .927.927l2.379-2.379 2.16 2.16a.654.654 0 0 0 .927 0z" })
});
export default SvgChartLineRegularIcon;
